import React, { useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { ADD_ACTIVITY, getApiBaseUrl } from "../../AssetMgt/Config/Config";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const Forgotpassword = () => {
  const route = all_routes;
  const [userID, setUserID] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    if (!userID) {
      alert("Please enter a User ID.");
      return;
    }

    setLoading(true);
    const performedOn = new Date().toISOString().slice(0, 19).replace("T", " ");
    let isSuccess = 0;
    let message = "";
    let performedBy = null; // null means no activity logging

    try {
      const payload = {
        username: userID,
      };

      const response = await fetch(`${getApiBaseUrl()}/forgotPassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        message =
          result?.Message || `Forgot password request sent for ${userID}`;
        isSuccess = result?.status ? 1 : 0;
        performedBy = result?.ResultData?.UserID ?? null; // ✅ only set if available

        Swal.fire({
          icon: "success",
          title: message,
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/signin");
        });
      } else {
        message =
          result?.Message || `Failed to initiate Forgot password for ${userID}`;
        Swal.fire({
          icon: "error",
          title: message,
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      message = "Something went wrong. Please try again.";
      Swal.fire({
        icon: "error",
        title: message,
        confirmButtonText: "OK",
      });
    } finally {
      // ✅ Call ADD_ACTIVITY only if we got a valid UserID
      if (performedBy) {
        try {
          const activityPayload = {
            ActivityType: 3,
            PerformedBy: performedBy,
            PerformedOn: performedOn,
            Notes: message,
            Location: "forgotpassword",
            IsSucces: isSuccess,
          };

          await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(activityPayload),
          });
        } catch (err) {
          console.error("Error calling addActivity:", err);
        }
      }

      setLoading(false);
    }
  };
  return (
    <>
      <div className="main-wrapper">
        <div className="account-content">
          <div className="login-wrapper">
            <div className="d-flex justify-content-center align-items-center w-100 row">
              <div className="card col-12 col-md-8 col-lg-4">
                <div className="card-body pb-0">
                  <form onSubmit={handleForgotPassword}>
                    <div className="login-userset">
                      <div className="login-logo logo-normal">
                        <ImageWithBasePath
                          src="assets/img/logo.png"
                          alt="img"
                        />
                      </div>
                      <Link
                        to={route.dashboard}
                        className="login-logo logo-white"
                      >
                        <ImageWithBasePath
                          src="assets/img/logo-white.png"
                          alt="Img"
                        />
                      </Link>
                      <div className="login-userheading d-flex justify-content-center">
                        <h3>Forgot password?</h3>
                      </div>
                      <div className="mb-3">
                        <div className="input-group">
                          <input
                            type="text"
                            value={userID}
                            onChange={(e) => setUserID(e.target.value)}
                            className="form-control border-end-0"
                            placeholder="User ID"
                            disabled={loading}
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-user" />
                          </span>
                        </div>
                      </div>
                      <div className="form-login d-flex justify-content-center mb-2">
                        <button
                          type="submit"
                          className="btn text-white w-50"
                          style={{
                            backgroundColor: "#0984E3",
                            borderColor: "#0984E3",
                          }}
                          disabled={loading}
                        >
                          {loading ? "Submitting..." : "Submit"}
                        </button>
                      </div>
                      <div className="signinform text-center">
                        <h5>
                          Return to
                          <Link
                            to={route.signin}
                            className="hover-a ms-1 text-primary"
                          >
                            login
                          </Link>
                        </h5>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="card-footer border-0 d-flex justify-content-center">
                  Filter Management System v.1.1.0
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Forgotpassword;
